import initAddressSearch from "./dadata-functions/initAddressSearch";
import pasteModalInDom from "./helpers/pasteModalInDom";
import initPersonalDataButtonsForOpen from "./helpers/initPersonalDataButtonsForOpen";
import initCheckNote from "./helpers/initCheckNote";
import setTariffFormButtonData from "./tariffModal";
import initPhoneMaskForModal from "./helpers/phoneMask";

const openModal = () => {
    const consultButtons = document.querySelectorAll('.consult-button');
    const menuButton = document.getElementById('menu-button');

    let consultModal = document.getElementById('consult-menu');
    const consultMenuModal= document.getElementById('consult-modal-menu');

    const addressPageMenuModal = document.getElementById('address-page-modal-menu');
    const tariffMenuModal= document.getElementById('tariff-modal-menu');
    const anotherAddressButtons = document.querySelectorAll('.another-address-button');
    const headerMoreMenuButton = document.querySelectorAll('.midle-header__item-more ');
    const headerMoreMenu = document.getElementById('header-more-list');
    const anotherAddressModal = document.getElementById('modal-address');
    const addressPageAnotherAddressModal = document.getElementById('address-page-modal-address');
    const tariffsButton = document.querySelectorAll('.free-consult__sent-button')
    const openReviewModalButtons = document.querySelectorAll('.review-open-button');
    let reviewModal = document.getElementById('review-modal');
    const closeReviewSuccessModal = document.getElementById('close-review-success-modal')
    const reviewSuccessModal = document.getElementById('review-success-modal');
    const closeFreeConsultationModal = document.getElementById('close-free-consultation-modal')
    const freeConsultationModal = document.getElementById('free-consultation-modal');
    let tariffModal = document.getElementById('tariff-modal');
    const tariffButtons = document.querySelectorAll('.tariff-button');
    const activeClass = 'active';
    let closePopupsBtn = document.querySelectorAll('.modal-close-circle');

    const closeAllModals = () => {
        if (consultModal !== null) {
            consultModal.classList.remove(activeClass);
        }

        if (consultMenuModal !== null) {
            consultMenuModal.classList.remove(activeClass);
        }
        if (reviewModal !== null) {
            reviewModal && reviewModal.classList.remove(activeClass);
        }
        if (tariffModal !== null) {
            tariffModal.classList.remove(activeClass);
        }

        if (tariffMenuModal !== null) {
            tariffMenuModal.classList.remove(activeClass);
        }

        addressPageMenuModal.classList.remove(activeClass);
        consultButtons.forEach(el => el.classList.remove(activeClass));
        menuButton.classList.remove(activeClass);
        anotherAddressModal && anotherAddressModal.classList.remove(activeClass);
        addressPageAnotherAddressModal && addressPageAnotherAddressModal.classList.remove(activeClass)
        reviewSuccessModal.classList.remove(activeClass);
        freeConsultationModal.classList.remove(activeClass);
    }

    function initAllClosePopupButtons() {
        closePopupsBtn = document.querySelectorAll('.modal-close-circle');
        closePopupsBtn.forEach((closeBtn) =>{
            closeBtn.addEventListener('click', closeAllModals);
        });
    }

    initAllClosePopupButtons();

    const closeTariffModal = document.getElementById('close-tariff-modal');
    if (closeTariffModal) {
        document.getElementById('close-tariff-modal').onclick = function () {
            document.getElementById('tariff-modal').classList.remove('active');
        };
    }


    let hideTimeout;
    headerMoreMenuButton.forEach(button => {
        button.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
            headerMoreMenu.classList.add('active');
        });

        button.addEventListener('mouseleave', () => {
            hideTimeout = setTimeout(() => {
                headerMoreMenu.classList.remove('active');
            }, 300);
        });
    });


    headerMoreMenu && headerMoreMenu.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout);
    });
    headerMoreMenu && headerMoreMenu.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
            headerMoreMenu.classList.remove('active');
        }, 300);
    });

    // freeConsultationButton.addEventListener('click', () => {
    //     const currentDisplay = window.getComputedStyle(freeConsultationModal).display;
    //     freeConsultationModal.style.display = currentDisplay === 'none' ? 'flex' : 'none';
    // });

    consultButtons && consultButtons.forEach(consultButton => {
        consultButton.addEventListener('click', async () => {
            if (!consultModal) {
                const ok = await pasteModalInDom('consult-menu');
                if (!ok) return;
                consultModal = document.getElementById('consult-menu');
                if (consultModal) {
                    initPhoneMaskForModal(consultModal);
                }
            }
            consultModal = document.getElementById('consult-menu');
            closePopupsBtn = document.querySelectorAll('.modal-close-circle');
            initAllClosePopupButtons();
            initPersonalDataButtonsForOpen();
            const formSuccess = consultModal.querySelector('.form-data__result');
            const form = consultModal.querySelector('.form-data__input');

            initCheckNote();
            if (consultModal.classList.contains(activeClass)) {
                closeAllModals();
            } else {
                closeAllModals();
                consultModal.classList.add(activeClass);
                consultButton.classList.add(activeClass);
                form.classList.remove('hide');
                formSuccess.classList.add('hide');
            }
        });
    })

    menuButton && menuButton.addEventListener('click', () => {
        if (addressPageMenuModal.classList.contains(activeClass)  ) {
            closeAllModals();
        } else {
            closeAllModals();
            addressPageMenuModal.classList.add(activeClass);
            menuButton.classList.add(activeClass);
        }
    });

    // код для изменения адреса
    anotherAddressButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (anotherAddressModal){
                if (anotherAddressModal.classList.contains(activeClass)) {
                    closeAllModals();
                } else {
                    closeAllModals();
                    anotherAddressModal.classList.add(activeClass);
                }
            }

            if (addressPageAnotherAddressModal){
                if (addressPageAnotherAddressModal.classList.contains(activeClass)) {
                    closeAllModals();
                } else {
                    closeAllModals();
                    addressPageAnotherAddressModal.classList.add(activeClass);
                    const search = document.getElementById("address-page-modal-address");
                    if (!search) return;
                    const input = search.querySelector(".street-input");
                    if (input) input.focus();
                    initAddressSearch();
                }
            }
        });
    });

    openReviewModalButtons && openReviewModalButtons.forEach(el => {
        el.addEventListener('click', async () => {

            if (!reviewModal) {
                let providers = JSON.parse(el.dataset.providers);
                const ok = await pasteModalInDom("review-modal", {providers,});
                if (!ok) return;
            }

            reviewModal = document.getElementById('review-modal');
            closePopupsBtn = document.querySelectorAll('.modal-close-circle');

            initCheckNote();

            initAllClosePopupButtons();
            initPersonalDataButtonsForOpen();

            if (reviewModal.classList.contains(activeClass)) {
                closeAllModals();
            } else {
                closeAllModals();

                reviewModal.classList.add(activeClass);
            }
        });
    })

    setTariffFormButtonData();


    closeReviewSuccessModal && closeReviewSuccessModal.addEventListener('click', () => closeAllModals());
    closeFreeConsultationModal && closeFreeConsultationModal.addEventListener('click', () => closeAllModals());

    addressPageMenuModal && addressPageMenuModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    consultMenuModal && consultMenuModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    tariffMenuModal && tariffMenuModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    consultModal && consultModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    anotherAddressModal && anotherAddressModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    addressPageAnotherAddressModal && addressPageAnotherAddressModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    reviewModal && reviewModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    reviewSuccessModal && reviewSuccessModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    freeConsultationModal && freeConsultationModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    tariffModal && tariffModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })
}

const consultForm = () => {
    const forms = document.querySelectorAll('.consult-form');

    forms.forEach(el => {
        const form = el;
        const timeSelect = form.querySelector('.select-js');
        const consultText = form.querySelector('.free-consult__sent-time__text');

        if (timeSelect && consultText){
            form.addEventListener('submit', (e) => {
                consultText.textContent = timeSelect.value
            });
        }
    });
}

const init = () => {
    openModal();
    consultForm();
}

document.addEventListener('DOMContentLoaded', init);
